import { Link } from "react-router-dom";
import type { Expense } from "@/models/types";
import CategoryBadge from "@/components/feature/CategoryBadge";
import { formatCurrency } from "@/utils/currency";
import { formatShortDate } from "@/utils/date";
import { paymentIcon } from "@/utils/format";

interface ExpenseTableProps {
  expenses: Expense[];
  currencyCode?: string;
}

export default function ExpenseTable({
  expenses,
  currencyCode = "MXN",
}: ExpenseTableProps) {
  return (
    <div className="hidden md:block bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 text-left text-foreground-500 text-xs uppercase tracking-wide">
              <th className="px-4 py-3 font-medium">Fecha</th>
              <th className="px-4 py-3 font-medium">Descripción</th>
              <th className="px-4 py-3 font-medium">Categoría</th>
              <th className="px-4 py-3 font-medium text-right">Importe</th>
              <th className="px-4 py-3 font-medium">Método</th>
              <th className="px-4 py-3 font-medium">Recibo</th>
              <th className="px-4 py-3 font-medium text-right">Acciones</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-background-200">
            {expenses.map((e) => (
              <tr
                key={e.id}
                className="hover:bg-background-100 transition-colors cursor-pointer"
              >
                <td className="px-4 py-3 text-foreground-700 whitespace-nowrap">
                  {formatShortDate(e.date)}
                </td>
                <td className="px-4 py-3">
                  <Link
                    to={`/gastos/${e.id}`}
                    className="font-medium text-foreground-900 hover:text-primary-600 truncate block max-w-[240px]"
                  >
                    {e.description}
                  </Link>
                </td>
                <td className="px-4 py-3">
                  <CategoryBadge categoryId={e.categoryId} />
                </td>
                <td className="px-4 py-3 text-right font-semibold text-foreground-950 whitespace-nowrap">
                  {formatCurrency(e.amount, currencyCode)}
                </td>
                <td className="px-4 py-3">
                  <span className="inline-flex items-center gap-1.5 text-foreground-600">
                    <i className={`${paymentIcon(e.paymentMethod)} text-base`} />
                  </span>
                </td>
                <td className="px-4 py-3">
                  {e.receipt ? (
                    <span className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                      <i className="ri-receipt-line" />
                    </span>
                  ) : (
                    <span className="text-foreground-300">—</span>
                  )}
                </td>
                <td className="px-4 py-3 text-right">
                  <Link
                    to={`/gastos/${e.id}`}
                    className="inline-flex w-8 h-8 items-center justify-center rounded-md hover:bg-secondary-200 text-foreground-600 cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-lg" />
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}